import React, { Component } from 'react';
import {
    Route,
    Switch,
} from 'react-router-dom';
import { isEmpty } from 'lodash';
import asyncRoute from '../../helpers/hoc/asyncRoute';
import routes from '../../routes';

import { PrivateRoute } from '../../utils/route-auth';
import { PERMISSION } from '../../constants/permission';

// const ADDMARGIN = asyncRoute(() => import('./AddMargin'));
const ERROR = asyncRoute(() => import('./ErrorFolder'));

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openAdUnitModal: false,
            openAdUnitGroupModal: false,
            openPMPModal: false,
            openMediationModal: false
        };
    }

    componentWillMount() {
        let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
        if (isEmpty(isAuthenticated)) {
            const { history } = this.props;
            history.push(routes.preSignIn);
        }
    }

    render() {
        const { match } = this.props;

        return (
            <div>
                <Switch>
                    <Route exact path={`${match.path}`} render={() =>
                        <ERROR match={match} />
                    }
                    />
                    <Route path={`${match.path}/${routes.containers.errors}`} component={ERROR}
                        // permissions={[PERMISSION.MARGIN.MARGIN.ADD]}
                        defaultRoute={'Erroe'} />
{/* 
                    <PrivateRoute path={`${match.path}/${routes.margin.editMargin}/:id`} component={ADDMARGIN}
                        permissions={[PERMISSION.MARGIN.MARGIN.EDIT]}
                        defaultRoute={'margin'} /> */}

                </Switch>

            </div>
        );
    }
}

export default index;
